import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, CardContent, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useCreateSeason } from "../api/SeasonApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { useNumericParams } from "../utils/useNumericParams";
import { SeasonForm } from "./SeasonForm";
export const CreateSeason = () => {
    const { id: leagueId } = useNumericParams();
    const navigate = useNavigate();
    const mutation = useCreateSeason({
        onMutate: () => { },
        onSuccess: (data) => {
            const season = data.data;
            navigate(`/leagues/${season.league}/seasons/${season.id}/`);
        },
        onError: () => { },
    });
    if (!leagueId) {
        return _jsx(ErrorView, { error: new Error("Missing league id") });
    }
    if (mutation.isLoading) {
        return _jsx(Loading, {});
    }
    const handleSubmit = (form) => {
        mutation.mutate({ ...form, league: leagueId });
    };
    return (_jsx(Card, { children: _jsxs(CardContent, { children: [_jsx(ErrorSnackbar, { open: mutation.isError, message: "Failed to create season. Please try again.", onClose: () => { } }), _jsx(Typography, { variant: "h6", gutterBottom: true, children: "Create Season" }), _jsx(SeasonForm, { onSubmit: handleSubmit })] }) }));
};
